import React from 'react';
import { motion } from 'framer-motion';
interface RadiantStarProps {
  size?: number;
  className?: string;
  animate?: boolean;
  delay?: number;
}
export function RadiantStar({
  size = 64,
  className = '',
  animate = true,
  delay = 0
}: RadiantStarProps) {
  return <motion.div className={`relative flex items-center justify-center ${className}`} style={{
    width: size,
    height: size
  }} initial={animate ? {
    opacity: 0,
    scale: 0.8
  } : undefined} animate={animate ? {
    opacity: 1,
    scale: 1
  } : undefined} transition={{
    duration: 1.5,
    delay: delay,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-203" data-mp="2g1ncemuu1e7i">
      {/* Star image */}
      <img src="https://cdn.magicpatterns.com/uploads/az44EqD7yjyqU7RDLHUkAw/Heldere-ster.jpg" alt="Bright star in night sky" className="w-full h-full object-cover rounded-full" style={{
      filter: 'brightness(1.1) contrast(1.05)',
      maskImage: 'radial-gradient(circle, white 20%, transparent 70%)',
      WebkitMaskImage: 'radial-gradient(circle, white 20%, transparent 70%)'
    }} data-id="element-204" data-mp="19fb0f2tc4ngz" />

      {/* Subtle pulsing glow animation */}
      {animate && <motion.div className="absolute inset-0 rounded-full" style={{
      boxShadow: '0 0 20px 8px rgba(200, 220, 255, 0.15)'
    }} animate={{
      opacity: [0.4, 0.7, 0.4],
      scale: [1, 1.05, 1]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-205" data-mp="6ck1tronq4ss" />}
    </motion.div>;
}